<template>
  <div class="">
    <button class="btn-indigo w-32 font-normal" @click="openModal()">Email</button>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Send Email
        </h1>
        <form id="emailForm" autocomplete="off" name="emailForm" @submit.prevent="sendEmail">
          <label class="form-label">Email To:</label>
          <div v-for="(email, index) in emailForm.emailTo" :key="email" class="tag-input__tag bg-indigo-600 text-white text-sm">
            <span class="deleteCheck" @click="removeEmail(index)">x</span>
            {{ email }}
          </div>
          <input
            type="text"
            placeholder="Enter an Email"
            class="tag-input__text text-sm"
            @keydown.enter="addEmail"
            @keydown.space="addEmail"
            @keydown.tab="addEmail"
            @keydown.delete="removeLastEmail"
          />
          <div v-if="emailForm.errors.emailTo" class="form-error pb-4">{{ emailForm.errors.emailTo }} Fix recipients before sending.</div>
          <label class="form-label">Email CC:</label>
          <div v-for="(email, index) in emailForm.emailCC" :key="email" class="tag-input__tag bg-indigo-600 text-white text-sm">
            <span class="deleteCheck" @click="removeEmailCC(index)">x</span>
            {{ email }}
          </div>
          <input
            type="text"
            placeholder="Enter an Email"
            class="tag-input__text text-sm"
            @keydown.enter="addEmailCC"
            @keydown.tab="addEmailCC"
            @keydown.space="addEmailCC"
            @keydown.delete="removeLastEmailCC"
          />
          <div v-if="emailForm.errors.emailCC" class="form-error pb-4">{{ emailForm.errors.emailCC }} Fix CCed recipients before sending.</div>
          <div class="w-full pb-4">
            <span id="addReferral" v-if="lead.contact_id" class="m-2 w-4 h-4 cursor-pointer text-xs text-indigo-400" @click="addReferralContactEmailCC"> CC Referral Contact</span>
            <span v-if="buyerAgentEmail" class="m-2 w-4 h-4 cursor-pointer text-xs text-indigo-400" @click="addBuyerAgentEmailCC"> CC Buyers Agent</span>
            <span v-if="sellerAgentEmail" class="m-2 w-4 h-4 cursor-pointer text-xs text-indigo-400" @click="addSellerAgentEmailCC"> CC Sellers Agent</span>
          </div>
          <select-input :key="emailTemplate.id" v-model="emailTemplate" class="pb-4 w-full" label="Email Template Options" @change="onTemplateChange($event)">
            <option v-for="emailSingle in emailTemplateOptions" :key="emailSingle.id" :value="emailSingle.id">{{ emailSingle.title }}</option>
          </select-input>
          <text-input v-model="emailForm.emailSubjectModal" :error="emailForm.errors.emailSubjectModal" class="pr-6 pb-4 w-full" label="Email Subject" />
          <label class="form-label">Email Message:</label>
          <div class="flex items-center gap-2 mb-2">
            <button
              id="loom-record-sdk-button"
              type="button"
              class="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 font-normal rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              @click="initializeLoom"
            >
              <i class="fas fa-video mr-2"></i>
              Record Video
            </button>
          </div>
          <EmailEditor
            v-model="emailForm.emailMessageModal"
            :error="emailForm.errors.emailMessageModal"
            ref="emailEditor"
            @change-email="updateEmail($event)"
          />
          <div v-if="emailForm.errors.emailMessageModal" class="form-error">{{ emailForm.errors.emailMessageModal }}</div>
          <attachment-uploader :initial-attachment-url="emailForm.attachment" message-type="email" @update:attachmentUrl="updateAttachmentUrl" @update:attachmentName="updateAttachmentName"/>
          <div class="flex justify-center items-center mt-5">
            <div>
              <loading-button :loading="emailForm.processing" class="btn-indigo ml-auto" type="submit">Send Email</loading-button>
            </div>
          </div>
        </form>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import EmailEditor from '@/Shared/EmailEditor'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import AttachmentUploader from '@/Shared/AttachmentUploader'
import { router, usePage } from '@inertiajs/vue3'
import { setup } from '@loomhq/record-sdk'
import { isSupported } from '@loomhq/record-sdk/is-supported'
import * as loomEmbedSDK from '@loomhq/loom-embed'

export default {
  components: {
    ModalHeadlessUI,
    EmailEditor,
    SelectInput,
    TextInput,
    LoadingButton,
    AttachmentUploader,
  },
  props: {
    lead:{
      type: Object,
      default: null,
    },
    userInfo: {
      type: Object,
      default: null,
    },
    emailTemplates: {
      type: Array,
      default: null,
    },
    referralContactEmail:{
      type: String,
      default: null,
    },
    buyerAgentEmail: {
      type: String,
      default: null,
    },
    sellerAgentEmail: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      emailForm: router.form({
        id: this.lead.id,
        emailTo: [this.lead.email],
        emailCC: [],
        emailSubjectModal: '',
        emailMessageModal: '',
        emailName: this.lead.fullName,
        attachmentName: null,
        attachment: null
      }),
      emailTemplate: '',
      attachmentError: '',
      buttonConfigured: false,
    }
  },
  computed:{
    // firstName(){
    //   var fullName = this.lead.fullName.trim().split(' ')
    //   var firstName = fullName[0]

    //   if(this.emailForm.emailCC == ''){
    //     return firstName
    //   }
    //   else{
    //     var fullNameCoborrower = this.lead.fullNameCoborrower.trim().split(' ')
    //     var firstNameCoborrower = firstName + ' and ' + fullNameCoborrower[0]
    //     return firstNameCoborrower
    //   }
    // },
    emailTemplateOptions() {
      var emailTemplateOptions= this.emailTemplates
      return emailTemplateOptions
    },
  },
  created() {
    if ((this.lead.emailCoborrower !== null && this.lead.emailCoborrower !== '')) {
      this.emailForm.emailCC.push(this.lead.emailCoborrower)
    }
  },
  methods:{
    validateEmail(email) {
      // Regular expression to validate email address
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return emailRegex.test(email)
    },
    addEmail (event) {
      event.preventDefault()
      var val = event.target.value.trim()
      if (this.validateEmail(val)) {
        this.emailForm.emailTo.push(val)
        event.target.value = ''
      } else {
        alert('Invalid To Email Address')
      }
    },
    removeEmail (index) {
      this.emailForm.emailTo.splice(index, 1)
    },
    removeLastEmail(event) {
      if (event.target.value.length === 0) {
        this.removeEmail(this.emailForm.emailTo.length - 1)
      }
    },
    addReferralContactEmailCC () {
      var val = this.referralContactEmail
      this.emailForm.emailCC.push(val)
    },
    addBuyerAgentEmailCC () {
      var val = this.buyerAgentEmail
      this.emailForm.emailCC.push(val)
    },
    addSellerAgentEmailCC () {
      var val = this.sellerAgentEmail
      this.emailForm.emailCC.push(val)
    },
    addEmailCC (event) {
      event.preventDefault()
      var val = event.target.value.trim()
      if (this.validateEmail(val)) {
        this.emailForm.emailCC.push(val)
        event.target.value = ''
      } else {
        alert('Invalid CC Email Address')
      }
    },
    removeEmailCC (index) {
      this.emailForm.emailCC.splice(index, 1)
    },
    removeLastEmailCC(event) {
      if (event.target.value.length === 0) {
        this.removeEmailCC(this.emailForm.emailCC.length - 1)
      }
    },
    removeAttachment() {
      this.emailForm.attachment=null
      this.emailForm.attachmentName=null
    },
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    onTemplateChange: function(event){

      let emailTemplateId = parseInt(event.target.value)
      console.log(emailTemplateId)

      this.emailForm.emailSubjectModal = this.emailTemplates.find(item => item.id === emailTemplateId).subject
      let message = this.emailTemplates.find(item => item.id === emailTemplateId).message
      let subject = this.emailTemplates.find(item => item.id === emailTemplateId).subject
      let attachment = this.emailTemplates.find(item => item.id === emailTemplateId).attachment

      Object.keys(this.lead).forEach(key => {
        const regex = new RegExp('%' + key + '%', 'g')
        message = message.replace(regex, this.lead[key])
        this.emailForm.emailMessageModal = message
        subject = subject.replace(regex, this.lead[key])
        this.emailForm.emailSubjectModal = subject
        this.emailForm.attachment = attachment
      })

      Object.keys(this.userInfo).forEach(key => {
        const regex = new RegExp('%' + key + '%', 'g')
        message = message.replace(regex, this.userInfo[key])
        this.emailForm.emailMessageModal = message.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '<br>')
        subject = subject.replace(regex, this.userInfo[key])
        this.emailForm.emailSubjectModal = subject
      })
    },
    updateEmail: function(emailValue){
      this.emailForm.emailMessageModal=emailValue
    },
    updateAttachmentUrl(url) {
      this.emailForm.attachment = url
    },
    updateAttachmentName(name) {
      this.emailForm.attachmentName = name
    },
    sendEmail() {
      // if (!Array.isArray(this.emailForm.emailTo) || this.emailForm.emailTo.length === 0) {
      //   alert('Please enter the recipient email address.')
      //   return
      // }
      this.emailForm.post('/email', {
        onSuccess: () => {
          this.emailForm.reset('emailTo')
          this.emailForm.reset('emailSubjectModal')
          this.emailForm.reset('emailMessageModal')
          this.emailForm.attachment=null
          this.emailForm.attachmentName=null
          this.closeModal()
          // console.log('posted')
        },
      })
    },
    async initializeLoom() {
      if (this.buttonConfigured) {
        return
      }

      const { supported, error } = await isSupported()

      if (!supported) {
        console.warn(`Error setting up Loom: ${error}`)
        return
      }

      const button = document.getElementById('loom-record-sdk-button')

      if (!button) {
        console.error('Loom button not found')
        return
      }

      try {
        console.log('Setting up Loom with public app ID:', usePage().props.loom.publicAppId)
        const { configureButton } = await setup({
          publicAppId: usePage().props.loom.publicAppId,
          mode: 'standard',
          insertButtonText: 'Add to Email',
          defaultTimeLimit: 300,
          config: {
            // Allow both screen+cam and cam-only recordings
            allowedRecordingTypes: ['screen_cam', 'cam'],
            // Enable picture in picture for better UX
            enablePictureInPicture: true,
            // Customize the appearance
            styles: {
              recordButtonColor: '#4F46E5', // Match your indigo theme
              primaryColor: '#4F46E5'
            }
          }
        })

        const sdkButton = configureButton({ element: button })

        this.buttonConfigured = true

        sdkButton.on('insert-click', async (video) => {
          try {
            console.log('Loom video object on insert-click:', video);
            const editor = this.$refs.emailEditor.editor;

            if (editor) {
              let duration = 1;
              const options = {
                width: 640,
                height: 360,
                gifThumbnail: true
              };
              const oembedData = await loomEmbedSDK.oembed(video.sharedUrl, options);
              console.log('Oembed data:', oembedData);

              if (oembedData.duration) {
                duration = Math.round(oembedData.duration);
              }

              const thumbnailHtml = `
                <div style="margin: 0; padding: 0; text-align: center; width: 100%; max-width: 640px; margin: auto;">
                  <a href="${video.sharedUrl}" target="_blank" style="text-decoration: none;">
                    <img src="${oembedData.thumbnail_url}" 
                         alt="Video Thumbnail: Click to watch the video" 
                         style="display: block; max-width: 100%; height: auto; border: 0; margin: 0 auto;" />
                  </a>
                  <p style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #333333; margin-top: 12px; text-align:center;">
                    <a href="${video.sharedUrl}" target="_blank" 
                       style="color: #3EB1E5; text-decoration: none; font-weight: bold;">
                      ▶️ Click Here to Watch: ${oembedData.title} (${duration}s)
                    </a>
                  </p>
                </div>
                <p>
                  Hey %first%,
                </p>
                <p>
                  I recorded a quick video for you! Click the link above to watch.
                </p>
              `;

              editor.model.change(writer => {
                const viewFragment = editor.data.processor.toView(thumbnailHtml);
                const modelFragment = editor.data.toModel(viewFragment);
                editor.model.insertContent(modelFragment);
              });

              const newContent = editor.getData();
              this.emailForm.emailMessageModal = newContent;
              this.updateEmail(newContent);
              this.$refs.emailEditor.data.description = newContent;
            }
          } catch (error) {
            console.error('Error inserting video:', error);
          }
        });

        // Add these event handlers to help debug
        sdkButton.on('recording-complete', (video) => {
          console.log('Recording complete:', video);
        });

        sdkButton.on('upload-complete', (video) => {
          console.log('Upload complete:', video);
        });

        sdkButton.on('processing-complete', (video) => {
          console.log('Processing complete:', video);
        });

      } catch (error) {
        console.error('Error setting up Loom button:', error)
      }
    },
  },
}
</script>

<style>
/* Add any additional styles needed */
</style>
